import { IonPage, IonContent } from '@ionic/react';
import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import './Cotizar.css';

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//     page_location: '/pages/Cotizar',
//     page_title: 'Cotizar'
//   }
// };

// console.log('Cotizar Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (Cotizar page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (Cotizar page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (Cotizar page_view):', error);
// });



const Cotizar: React.FC = () => {
    const url = "https://portal.mastinseguridad.com/storage/cotizacion.html";
    return (
        <IonPage>
            <Header pageName="Nuestras soluciones" />
            <IonContent className="pqrs-content" id="pqrs">
                <iframe className="pqrs-comment web-view cotizar" src={url} frameBorder="1"></iframe>
            </IonContent>
            <Footer />
        </IonPage>
    );
}

export default Cotizar;